import React, { ComponentType } from 'react';

import { de, enGB, es, fr } from 'date-fns/locale';
import DatePicker, { registerLocale } from 'react-datepicker';

import { useProfile } from 'auth/Auth';
import { LocaleCode } from 'core/util/Locale';

// @see React DatePicker https://reactdatepicker.com/

// @see Supported locales https://date-fns.org/v2.0.0-alpha.18/docs/I18n
export enum SupportedLocale {
    'en-US' = 'en-US', // Default
    'enGB' = 'enGB',
    'de' = 'de',
    'es' = 'es',
    'fr' = 'fr',
}

registerLocale('enGB', enGB);
registerLocale('de', de);
registerLocale('es', es);
registerLocale('fr', fr);

const withLocale = <P extends object>(Component: ComponentType<P>) => {
    return (props: any): JSX.Element => {
        let { locale } = props;

        if (!locale) {
            const [{ profile }] = useProfile();

            switch (profile?.user.locale) {
                case LocaleCode.en_GB:
                    locale = SupportedLocale.enGB;
                    break;

                case LocaleCode.de_CH:
                case LocaleCode.de_DE:
                    locale = SupportedLocale.de;
                    break;

                case LocaleCode.es_ES:
                case LocaleCode.es_MX:
                    locale = SupportedLocale.es;
                    break;

                case LocaleCode.fr_CA:
                case LocaleCode.fr_FR:
                    locale = SupportedLocale.fr;
                    break;

                default:
                    break;
            }
        }

        return <Component locale={locale} {...props} />;
    };
};

export const DatePickerWithLocale = withLocale(DatePicker);
